<div>
    <ng-container *ngIf="(confirmStepActionDetails$ | async) as confirmStepActionDetails" >
        <div *ngIf="(confirmStepActionDetails.isActive && confirmStepActionDetails.canUserPerformStep) || disableIfNotActive"
             [tooltipPosition]="'BOTTOM'"
             [tooltipShow]="true"
             [tooltipText]="confirmStepActionDetails.disabledTooltipText || (confirmStepActionDetails.isTooltipEnabled$ | async)"
             genTooltip>
            <gen-button (click)="confirmActiveStep()" 
             [disabled]="!(confirmStepActionDetails.isEnabled$ | async) 
                        || !confirmStepActionDetails?.isActive 
                        || !confirmStepActionDetails?.canUserPerformStep"
             [text]="confirmStepActionDetails.text"
             [type]="confirmStepActionDetails.type"
             class='btn-confirm-button'>
            </gen-button>
        </div>
    </ng-container>
</div>
